<template>
  <piece-card title="人流动态">
    <div class="crowd-list flex-box">
      <InfoCard v-for="(item, index) in showList" :key="index" :title="item.title" :value="item.value" class="info-item flex-grow" />
    </div>
  </piece-card>
</template>

<script>
import PieceCard from "../../components/piece-card.vue";
import InfoCard from "../../components/info-card.vue";

export default {
  name: "Crowd",
  components: {
    PieceCard,
    InfoCard,
  },
  props: {
    info: { type: Object },
  },
  data() {
    return {};
  },
  computed: {
    showList() {
      const { rldt = {} } = this.info || {};
      return [
        { title: "当前在寺人数", value: rldt.now || 0 },
        { title: "今日游客接待量", value: rldt.all || 0 },
      ];
    },
  },
  methods: {},
};
</script>

<style lang="less" scoped>
.info-item {
  &:not(:last-of-type) {
    margin-right: 5px;
  }
}
</style>
